<app-header-landing></app-header-landing>
<div id="main">
  <div class="section" id="section">
    <div id="login">
      <div class="title-container">
        <h1>{{ "login.login" | translate }}</h1>
      </div>

      <div class="form">
        <mat-form-field appearance="outline">
          <mat-label for="eventTitle">{{
            "login.placeholder_card" | translate
            }}</mat-label>
          <input #myUser="ngModel" matInput placeholder="{{ 'login.placeholder_card' | translate }}"
            [(ngModel)]="username" name="username" autocomplete="username"
            userValidator="^[1-9a-zA-Z][0-9a-zA-Z\-\_]*$" />
          @if (myUser.invalid && (myUser.dirty || myUser.touched)) {
            <mat-error>
              @if (myUser.errors?.['userInvalid']) {
                {{ "login.card_invalid" | translate }}
              }
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label for="eventTitle">{{
            "login.placeholder_pass" | translate
            }}</mat-label>
          <input #myPassword="ngModel" matInput type="text" placeholder="{{ 'login.placeholder_pass' | translate }}"
            [(ngModel)]="password" name="password" autocomplete="current-password"
            dateValidator="^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$" (input)="onDateInput($event)"
            maxlength="10" />
          @if (myPassword.invalid && (myPassword.dirty || myPassword.touched)) {
            <mat-error >
              @if (myPassword.errors?.['dateInvalid']) {
                {{ "login.date_invalid" | translate }}
              }
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            "login.ship" | translate
            }}</mat-label>
          <mat-select #myship="ngModel" [(ngModel)]="selectedShip" name="shipSelect"  required>
            @for (ship of availableShips; track ship.id) {
              <mat-option [value]="ship" >
                {{ ship.name }}
              </mat-option>
            }

          </mat-select>
          @if (myship.invalid && (myship.dirty || myship.touched)) {
            <mat-error>
              {{ "login.select_ship" | translate }}
            </mat-error>
          }

        </mat-form-field>

        <div [hidden]="!wrongInput">{{ "login.data_invalid" | translate }}</div>

        <div class="btn-container">
          <button class="my-button" (click)="login()" [disabled]="
              !username || !password || !selectedShip || myPassword.invalid || myUser.invalid || myship.invalid
            ">
            {{ "login.enter" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
